import { makeStyles } from '@mui/styles'

export const useFormInputStyles = makeStyles(() => ({
  dateTimePickers: {
    margin: 0,
    width: '100%',
  },
  alignCheckboxTop: {
    alignItems: 'flex-start',
  },
}))
